import { $t } from '@/utils/languageAuto';

var render = function () {
  var this$1 = this;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.visible ? _c('my-modal', {
    attrs: {
      "width": 850,
      "data-sign": "my_account_add_or_edit_payment_account_modal",
      "title": _vm.payId ? _vm.t('编辑付款账户') : _vm.t('新增付款账户')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "my_account_add_or_edit_payment_account_form",
      "model": _vm.formData,
      "form": _vm.formData,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u7B2C\u4E09\u65B9\u5E73\u53F0"),
      "prop": "isthird_party",
      "label": _vm.t('是否第三方平台')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择')
    },
    on: {
      "change": _vm.handleIsthirdPartyChange
    },
    model: {
      value: _vm.formData.isthird_party,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isthird_party", $$v);
      },
      expression: "formData.isthird_party"
    }
  }, _vm._l(_vm.IsThirdPartEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": String(item.value)
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('common-tips', {
    attrs: {
      "data": [_vm.t('使用第三方支付平台付款（例如：pingpong、P卡）。')]
    }
  })], 1), _vm.payId && _vm.detailData.pay_account_status === _vm.$enum.finance.PayAccountStatusEnum.APPROVE ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u7B2C\u4E09\u65B9\u652F\u4ED8"),
      "prop": "is_unofficial",
      "label": _vm.t('是否第三方支付')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "value": _vm.detailData.is_unofficial,
      "placeholder": _vm.t('请选择'),
      "disabled": ""
    }
  }, _vm._l(_vm.paymentAccountUnOfficialEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('common-tips', {
    attrs: {
      "data": [_vm.t('付款账户的开户主体与签约主体不一致。')]
    }
  })], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u94F6\u884C\u540D\u79F0"),
      "prop": "pay_bank_code",
      "label": _vm.t('银行名称')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择'),
      "show-search": ""
    },
    on: {
      "change": _vm.handlepayBankCodeChange
    },
    model: {
      value: _vm.formData.pay_bank_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "pay_bank_code", $$v);
      },
      expression: "formData.pay_bank_code"
    }
  }, _vm._l(_vm.bankFilterList, function (item) {
    return _c('a-select-option', {
      key: item.bank_code,
      attrs: {
        "value": item.bank_code
      }
    }, [_vm._v(_vm._s(item.bank_name))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u6237\u540D\u79F0"),
      "prop": "pay_account_name",
      "label": _vm.t('账户名称')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": _vm.editDisabled,
      "maxLength": 255,
      "placeholder": _vm.t('如果属于与亿格交易的，需填写纯英文字符')
    },
    on: {
      "change": _vm.handlePayAccountNameChange
    },
    model: {
      value: _vm.formData.pay_account_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "pay_account_name", $$v);
      },
      expression: "formData.pay_account_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u53F7"),
      "prop": "pay_account",
      "label": _vm.t('账号')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "disabled": _vm.editDisabled,
      "maxLength": 50
    },
    model: {
      value: _vm.formData.pay_account,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "pay_account", $$v);
      },
      expression: "formData.pay_account"
    }
  })], 1), _vm.formData.isthird_party === String(_vm.$enum.common.BoolIntEnum.NO) ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5F00\u6237\u884C\u56FD\u5BB6/\u5730\u533A"),
      "prop": "open_bank_country_code",
      "label": _vm.t('开户行国家/地区')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择'),
      "show-search": ""
    },
    on: {
      "change": _vm.handleOpenBankCountryChange
    },
    model: {
      value: _vm.formData.open_bank_country_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "open_bank_country_code", $$v);
      },
      expression: "formData.open_bank_country_code"
    }
  }, _vm._l(_vm.registerCountryList, function (item) {
    return _c('a-select-option', {
      key: item.country_code,
      attrs: {
        "value": item.country_code
      }
    }, [_vm._v(_vm._s(item.country_name))]);
  }), 1), _vm.isShowCaBankTip ? _c('common-tips', {
    staticStyle: {
      "color": "#FF8D3D"
    },
    attrs: {
      "data": [$t("\u52A0\u62FF\u5927\u5F53\u5730\u4ED8\u6B3E\u65F6\u9700\u8981\u4ED8\u6B3E\u4EBA\u63D0\u4F9B\u6536\u6B3E\u4EBA\u5730\u5740\u4FE1\u606F\u3002\u6B64\u94F6\u884C\u5361\u672A\u6765\u53EF\u80FD\u7528\u4E8E\u63A5\u6536\u9000\u6B3E\uFF0C\u56E0\u6B64\u9700\u8981\u63D0\u524D\u63D0\u4F9B\u3002")]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.formData.isthird_party === String(_vm.$enum.common.BoolIntEnum.NO) ? _c('a-form-model-item', {
    attrs: {
      "prop": "open_bank_name",
      "label": _vm.t('开户行名称')
    }
  }, [_vm.formData.open_bank_country_code === _vm.$enum.mine.RegisterAreaCodeEnum.CN ? _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择'),
      "show-search": ""
    },
    on: {
      "change": _vm.handleOpenBankNameChange,
      "search": _vm.handleOpenBankListSearch
    },
    model: {
      value: _vm.formData.open_bank_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "open_bank_name", $$v);
      },
      expression: "formData.open_bank_name"
    }
  }, _vm._l(_vm.showOpenBankList, function (item) {
    return _c('a-select-option', {
      key: item.bank_branch_name,
      attrs: {
        "value": item.bank_branch_name
      }
    }, [_vm._v(_vm._s(item.bank_branch_name))]);
  }), 1) : _vm._e(), _vm.formData.open_bank_country_code === _vm.$enum.mine.RegisterAreaCodeEnum.CN ? _c('div', {
    staticClass: "select-tip"
  }, [_vm._v(_vm._s(_vm.t('最多列出100条记录，请输入关键词筛选。')))]) : _c('my-input', {
    staticClass: "form-item-input",
    model: {
      value: _vm.formData.open_bank_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "open_bank_name", $$v);
      },
      expression: "formData.open_bank_name"
    }
  })], 1) : _vm._e(), _vm.formData.isthird_party === String(_vm.$enum.common.BoolIntEnum.NO) && _vm.formData.open_bank_country_code === _vm.$enum.mine.RegisterAreaCodeEnum.CN ? _c('a-form-model-item', {
    key: "payment_lines",
    attrs: {
      "fbu-analyse-name": $t("\u8054\u884C\u53F7"),
      "prop": "payment_lines",
      "label": _vm.t('联行号')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.formData.payment_lines,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "payment_lines", $$v);
      },
      expression: "formData.payment_lines"
    }
  })], 1) : _vm._e(), _vm.isShowSwiftCode ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name":
      /*no-i18n-auto*/
      'Swift Code',
      "prop": "swift_code",
      "label": _vm.t('Swift Code')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    model: {
      value: _vm.formData.swift_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "swift_code", $$v);
      },
      expression: "formData.swift_code"
    }
  }), _vm.isShowSwiftCodeTip ? _c('common-tips', {
    staticStyle: {
      "color": "#FF8D3D"
    },
    attrs: {
      "data": [_vm.t('Swift Code（又称 BIC 代码）是国际银行唯一识别码，开户行国家、谷仓主体非中国大陆或结算币种非CNY，必须提供 Swift Code，否则会导致退款失败。')]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isShowBsbCode ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5883\u5185\u6C47\u6B3E\u4EE3\u7801"),
      "prop": "bsb_code",
      "label": _vm.t('境内汇款代码')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "disabled": _vm.isBsbCodeDisabled
    },
    model: {
      value: _vm.formData.bsb_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "bsb_code", $$v);
      },
      expression: "formData.bsb_code"
    }
  }), _c('common-tips', {
    attrs: {
      "data": [_vm.t('本地汇款需要提供,如BSBcode/Routing number/Sort Code等')]
    }
  })], 1) : _vm._e(), _vm.isShowPayeeInfo ? _c('payee-info', {
    ref: "payeeInfo",
    attrs: {
      "formData": _vm.formData,
      "registerCountryList": _vm.registerCountryList
    }
  }) : _vm._e(), _c('a-form-model-item', {
    staticClass: "currency_codes",
    attrs: {
      "fbu-analyse-name": $t("\u53EF\u5145\u503C\u5E01\u79CD"),
      "prop": "currency_codes",
      "label": _vm.t('可充值币种')
    }
  }, [_c('div', [_c('a-checkbox-group', {
    model: {
      value: _vm.formData.currency_codes,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "currency_codes", $$v);
      },
      expression: "formData.currency_codes"
    }
  }, _vm._l(_vm.currencyList, function (item) {
    return _c('a-checkbox', {
      key: item.currency_code,
      attrs: {
        "value": item.currency_code
      }
    }, [_vm._v(" " + _vm._s(item.currency_code) + " ")]);
  }), 1)], 1)]), _vm.payId ? [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u53EF\u5145\u503C\u8D26\u6237"),
      "prop": "account_code",
      "label": _vm.t('可充值账户')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": _vm.editDisabled,
      "placeholder": _vm.t('请选择')
    },
    model: {
      value: _vm.formData.account_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account_code", $$v);
      },
      expression: "formData.account_code"
    }
  }, _vm._l(_vm.accountCodeList, function (item) {
    return _c('a-select-option', {
      key: item.account_code,
      attrs: {
        "disabled": item.disabled,
        "value": item.account_code
      }
    }, [_vm._v(" " + _vm._s(item.account_code) + " " + _vm._s(item.sign_body_name) + " " + _vm._s(item.sign_business_list_text) + " ")]);
  }), 1)], 1), _vm.isShowEntrust ? [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u59D4\u6258\u4ED8\u6B3E\u51FD"),
      "label": _vm.t('委托付款函'),
      "prop": "attachment_url"
    }
  }, [_c('my-upload', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "data": [],
      "checkError": _vm.onCheckError,
      "before-upload": function (file) {
        return _vm.onBeforeUpload_prove_file(file, -1);
      },
      "validate-type": "PayAttachmentRule"
    }
  }, [_c('a-button', [_vm._v(_vm._s(_vm.t('选择文件')))])], 1), _vm.formData.preview_url ? _c('a', {
    staticClass: "ml-5",
    attrs: {
      "target": "_blank",
      "href": _vm.formData.preview_url,
      "fbu-analyse-name": $t("\u4E0B\u8F7D")
    }
  }, [_c('a-icon', {
    staticClass: "ml-5",
    attrs: {
      "type": "download"
    }
  }), _vm._v(_vm._s(_vm.t('下载')) + " ")], 1) : _vm._e()], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u53D7\u6258\u5173\u7CFB"),
      "label": _vm.t('受托关系'),
      "prop": "fiduciary"
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择受托关系')
    },
    model: {
      value: _vm.formData.fiduciary,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "fiduciary", $$v);
      },
      expression: "formData.fiduciary"
    }
  }, _vm._l(_vm.paymentAccountFiduciaryEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('common-tips', {
    attrs: {
      "data": [_vm.t('委托人与受托人关系。')]
    }
  })], 1), _vm.formData.fiduciary === _vm.$enum.finance.PaymentAccountFiduciaryEnum.OTHER ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u53D7\u6258\u5173\u7CFB\u63CF\u8FF0"),
      "label": _vm.t('受托关系描述'),
      "prop": "fiduciary_desc"
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "maxLength": 100,
      "allow-clear": "",
      "placeholder": _vm.t('请输入')
    },
    model: {
      value: _vm.formData.fiduciary_desc,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "fiduciary_desc", $$v);
      },
      expression: "formData.fiduciary_desc"
    }
  })], 1) : _vm._e()] : _vm._e()] : [_c('a-form-model-item', {
    staticClass: "account-infos",
    attrs: {
      "fbu-analyse-name": $t("\u53EF\u5145\u503C\u8D26\u6237"),
      "prop": "accountCodeIds",
      "label": _vm.t('可充值账户')
    }
  }, [_c('div', {
    staticClass: "mt-10 mb-10"
  }, [_c('a', {
    attrs: {
      "href": _vm.bizList.entrust_payment_template,
      "data-sign": "my_account_add_payaccount_template_download",
      "fbu-analyse-name": $t("\u4E0B\u8F7D\u6A21\u677F")
    }
  }, [_vm._v(_vm._s(_vm.t('下载模板')))])]), _c('a-checkbox-group', {
    on: {
      "change": function () {
        return _vm.validFormField(['accountCodeIds']);
      }
    },
    model: {
      value: _vm.formData.accountCodeIds,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "accountCodeIds", $$v);
      },
      expression: "formData.accountCodeIds"
    }
  }, [_vm._l(_vm.accountCodeList, function (item, index) {
    return [_c('a-form-model-item', {
      key: item.account_code,
      attrs: {
        "prop": "accountCodeIds." + index,
        "rules": _vm.formDataRule['accountCodeIds.*']
      }
    }, [_c('a-checkbox', {
      key: item.account_code,
      attrs: {
        "value": item.account_code
      }
    }, [[_vm._v(_vm._s(item.account_code) + " " + _vm._s(item.sign_body_name) + " " + _vm._s(item.sign_business_list_text))]], 2), _vm.formData.accountCodeIds.includes(item.account_code) && _vm.isUnOfficePayByName(item) ? _c('div', {
      key: item.account_code,
      staticClass: "account-infos-entrust",
      staticStyle: {
        "margin-left": "23px"
      }
    }, [_c('my-select', {
      staticClass: "form-item-select fiduciary",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "fbu-analyse-name": $t("\u8BF7\u9009\u62E9\u53D7\u6258\u5173\u7CFB"),
        "placeholder": _vm.t('请选择受托关系'),
        "show-pre-tip": "",
        "pre-tip-content": _vm.t('委托人与受托人关系')
      },
      on: {
        "change": function () {
          return _vm.validFormField(["accountCodeIds." + index]);
        }
      },
      model: {
        value: item.fiduciary,
        callback: function ($$v) {
          _vm.$set(item, "fiduciary", $$v);
        },
        expression: "item.fiduciary"
      }
    }, _vm._l(_vm.paymentAccountFiduciaryEnum, function (item) {
      return _c('a-select-option', {
        key: item.value,
        attrs: {
          "value": item.value
        }
      }, [_vm._v(_vm._s(item.text))]);
    }), 1), item.fiduciary === _vm.$enum.finance.PaymentAccountFiduciaryEnum.OTHER ? _c('my-input', {
      staticClass: "form-item-input fiduciary_desc ml-10",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "fbu-invalid-analyse-tag": true,
        "allow-clear": "",
        "placeholder": _vm.t('请输入受托关系描述'),
        "maxLength": 100
      },
      on: {
        "change": function () {
          return _vm.validFormField(["accountCodeIds." + index]);
        }
      },
      model: {
        value: item.fiduciary_desc,
        callback: function ($$v) {
          _vm.$set(item, "fiduciary_desc", $$v);
        },
        expression: "item.fiduciary_desc"
      }
    }) : _vm._e(), _c('my-upload', {
      staticClass: "add-upload ml-10",
      attrs: {
        "data": [],
        "name": "file",
        "checkError": _vm.onCheckError,
        "before-upload": function (file) {
          return _vm.onBeforeUpload_prove_file(file, index);
        },
        "validate-type": "PayAttachmentRule"
      }
    }, [_c('a', {
      staticClass: "btn",
      attrs: {
        "href": "javascript:;",
        "fbu-analyse-name": $t("\u4E0A\u4F20\u59D4\u6258\u4ED8\u6B3E\u51FD")
      }
    }, [_vm._v(_vm._s(_vm.t('上传委托付款函')))])]), item.preview_url ? _c('a', {
      staticClass: "download-btn",
      attrs: {
        "target": "_blank",
        "download": item.attachment_name,
        "href": item.preview_url
      }
    }, [_c('a-icon', {
      attrs: {
        "type": "download"
      }
    })], 1) : _vm._e()], 1) : _vm._e()], 1)];
  })], 2)], 1)], _vm.isShowDisclaimer ? _c('payment-account-disclaimer', {
    attrs: {
      "formData": _vm.formData
    }
  }) : _vm._e(), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.t('提示：当付款账户名与签约主体名称不一致时，需要上传委托付款函，支持PDF/ZIP/PNG/JPG,不超过30M。')))])], 2), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "finance_pay_account_form_cancel",
      "id": "finance_pay_account_form_cancel",
      "data-sign": "my_account_add_or_edit_payment_account_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function () {
        return this$1.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "finance_pay_account_form_submit",
      "id": "finance_pay_account_form_submit",
      "data-sign": "my_account_add_or_edit_payment_account_submit",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))])], 1)], 1) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };